<template>
  <div v-if="isVerificationEditor">
    <h1>Associated TMLN</h1>
    <div v-if="!isBusy && (!model || model?.companiesHouse === null)" class="alert alert-warning">
      No Associated TMLNs data available.
    </div>
    <table
      v-if="model && model.companiesHouse?.trustMarkBusinesses?.length > 0"
      class="table table-hover"
    >
      <thead>
        <tr>
          <th scope="col">Company Number</th>
          <th scope="col">Company Name</th>
          <th scope="col">Officers</th>
          <th scope="col">TMLN</th>
          <th scope="col">Status</th>
          <th scope="col">Suspended</th>
          <th scope="col">linked Scheme Businesses Count</th>
          <th scope="col">Main Input</th>
          <th scope="col">Query Time</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="tmb in model.companiesHouse.trustMarkBusinesses"
          :key="tmb.registeredCompanyNumber"
        >
          <td>{{ tmb.registeredCompanyNumber }}</td>
          <td>{{ tmb.registeredCompanyName }}</td>
          <td>
            <div class="my-2" v-for="(officer, idex) in tmb.officers" :key="idex">
              {{ officer }}
            </div>
          </td>
          <td>
            <router-link :to="`/tmlns/${tmb.trustmarkBusinessId}`">
              {{ tmb.tmln }}
            </router-link>
          </td>
          <td>{{ tmb.status }}</td>
          <td>{{ tmb.isSuspended ? "Yes" : "No" }}</td>
          <td>{{ tmb.linkedSchemeBusinessesCount }}</td>
          <td>{{ tmb.isMainInput ? "Yes" : "No" }}</td>
          <td>{{ this.$helpers.dateString(tmb.queryTimestamp) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: "SchemeBusinessVerificationAssociatedBusinessList",
  data() {
    return {
      errorMessage: null,
    };
  },
  computed: {
    currentAccount() {
      return this.$store.state.auth.account;
    },
    isVerificationEditor() {
      return this.currentAccount && this.currentAccount.roles
        ? this.currentAccount.roles.includes("VerificationEditor")
        : false;
    },
    model() {
      return this.$store.state.schemeBusiness.verification;
    },
    isBusy() {
      return this.$store.state.isBusy;
    },
  },
  async mounted() {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    if (!this.model) {
      await this.$store.dispatch("schemeBusiness/getVerification", {
        schemeBusinessId: this.$route.params.schemeBusinessId,
        schemeId: this.$route.params.schemeId,
      });
    }
  },
};
</script>
